import { useEffect } from "react";
import { useAppDispatch } from "../../../../app/hooks";
import {
  changeConfigurationActiveComponent,
  changeHelpActiveComponent,
} from "../../configurationSlice";
import { changeCurrentProduct } from "../../../common/commonSlice";

export const CoreIdHelp = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(changeConfigurationActiveComponent("Help"));
    dispatch(changeHelpActiveComponent("Documentacion CoreId"));
    dispatch(changeCurrentProduct("Ayuda y Documentacion"));
  }, []);
  return (
    <div
      style={{
        overflow: "auto",
        color: "white",
        padding: "2% 2%",
        width: "100%",
        height: "100%",
      }}
    >
      <h2
        style={{
          fontWeight: "bold",
          fontSize: "52px",
        }}
      >
        CoreId
      </h2>
      <p>
        El servicio CoreId de anteia es una herramienta de verificación
        multifactorial de identidad.
      </p>
      <p>
        Esta herramienta se encarga de verificar, a través de multiples
        factores, que la persona que se registra es quien dice ser y que tiene
        los requisitos para realizar el tipo de vinculación que se requiere.
      </p>
      <p>
        El siguiente manual le dará una descripción de cada una de las secciones
        del servicio dentro del backoffice. Esto le ayudará a entender como
        realizar la navegación, interpretar los datos y realizar las acciones
        que requiera.
      </p>
      <object
        data="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20BACKOFFICE%20-%20COREID.pdf"
        type="application/pdf"
        width="100%"
        height="100%"
      >
        <p>
          Descarga alternativa:{" "}
          <a href="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20BACKOFFICE%20-%20COREID.pdf">
            Si no se ve puede dar click aquí para descargar el PDF
          </a>
        </p>
      </object>

      <h2
        style={{
          fontWeight: "bold",
          fontSize: "36px",
        }}
      >
        Documentación de API
      </h2>
      <p>
        Además de manejo de la plataforma también ofrecemos documentación del
        API de CoreId, la cual puede consultar en el siguiente enlace:
      </p>
      <a
        href="https://anteia.stoplight.io/docs/clients-api/36a9ac7534b9e-core-id-api"
        target="blank
      "
      >
        Documentación API
      </a>
    </div>
  );
};
